export const testAccountId = 'act_R7CMrhPzRdLpMBtKPDthLf7gC';
export const testKeyId = 'pk_test_GTt9fFFzrTgGTLMQLg6nq96L9';
